import React, { useContext, useEffect, useRef, useState } from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

import Checkers from '../../../../../../helpers/class/Checkers';
import * as appContext from '../../../../../AppContext';
import ServiceContent from '../../../partials/services/ServiceContent';
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import {Swiper} from "swiper/react";

export default function TermsViewPort ( props ) {

    const showDivHandler = () => {
        if ((Checkers.isValidArray(props.terms) && props.terms.length > 0) || Checkers.isValidString(props.terms)) {
            return true
        }

        if (props.hasOwnProperty('descRules') && props.descRules.length > 0) {
            return true
        }

        return false
    }

    return (
        <>
            {
                showDivHandler() ?
                    <>
                        <div id="pro_detail_desc" className="pb-5">
                            {
                                (Checkers.isValidArray(props.terms) && props.terms.length > 0) || Checkers.isValidString(props.terms) ?
                                    <>
                                        <p className="block-title m-t-40 hint-text no-margin">Policies</p>
                                        <h2 className="m-t-5">Accommodation rules and policies</h2>
                                        {
                                            Checkers.isValidArray(props.terms) && props.terms.length > 0 ?
                                                <ul>
                                                    {
                                                        props.terms.length > 0 && props.terms.map((item) => {
                                                            return (
                                                                <>
                                                                    <li>{item}</li>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                                :
                                                <>
                                                    {
                                                        Checkers.isValidString(props.terms) ?
                                                            <div dangerouslySetInnerHTML={{__html: props.terms}}/>
                                                            :
                                                            <></>
                                                    }
                                                </>
                                        }
                                    </>
                                    :
                                    <>
                                    </>
                            }
                            {
                                (props.hasOwnProperty('descRules') && props.descRules.length > 0) && props.terms!=props.descRules ?
                                    <>
                                        <div className={'mt-2'} dangerouslySetInnerHTML={{__html: props.descRules}}/>
                                    </>
                                    :
                                    <>
                                    </>
                            }
                        </div>
                    </>
                    :
                    <>
                    </>
            }
        </>
    )
}
